import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addRequestInitiation = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/request`,
    data,
  );
  return response.data;
};

export const updateRequestInitiation = async (reqData) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/request`,
    reqData,
  );
  return response.data;
};

export const fetchDataById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/request/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const fetchJobIdsByRequestId = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job/by-request/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const fetchInsIdsByJobId = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.FINANCE}/job-charge-confirmation/by-job/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const isSameLocationsAllowed = async (shipmentType, stkId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/request/allow-same-loc/${shipmentType}/${stkId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const fetchJobConfirmationAlerts = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/job-confirmation-alerts`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const fetchBackhaulSuggestions = async (requestId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/backhaul/suggestions/${requestId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const approveBackhaul = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/backhaul/approve`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
  };

  export const createAndApproveRequestInitiation = async (data) => {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/request/create-and-approve`,
      data,
    );
    return response.data;
  
};
